import api from "@/api/axios/axios.js";

// 1) Crear el job: responde al instante con un id. KnowledgeHub service.
// NO atrapamos el error: si falla, se propaga para que procesar() lo maneje
// (si devolviéramos un string, se usaría como id y romperia status/<id>/).
export async function getJobKnowledge(body) {
   const { data } = await api.post("/login/knowledgehub/", body);
   return data?.id ?? data?.job_id;
}

export async function getStatus(id) {
   const { data } = await api.get(`/login/knowledgehub/status/${id}/`);
   return data;
}

// Resultado final del job (artefactos generados, etc.)
// GET /catalog/knowledgehub/result/<khjob_id>/
export async function getKnowledgeResult(id) {
   const { data } = await api.get(`/login/knowledgehub/result/${id}/`);
   return data;
}


